export default "__VITE_ASSET__c65e2231__$_?component__"